import React from 'react';
import '../App.css';
export default function ButtonsOnly() {
  return (
    <div className="buttons-wrapper">
      <a
        href="https://algoheads.featurebase.app"
        target="_blank"
        rel="noopener noreferrer"
        className="button suggest"
      >
        Suggest Feature
      </a>
      <a
        href="https://getwaitlist.com/waitlist/27552"
        target="_blank"
        rel="noopener noreferrer"
        className="button waitlist"
      >
        Join Waitlist
      </a>
    </div>
  );
}
